import { CustomSelectFieldProps, SelectField } from 'components/form'
import { TipoParticipacaoAtendimentoEnum } from 'graphql/types.generated'
import { tipoParticipacaoAtendimentoRecord } from 'view/atendimentos/detail/soap/finalizacao/model-finalizacao'

export type TipoParticipacaoAtendimentoSelectModel = TipoParticipacaoAtendimentoEnum

type TipoParticipacaoAtendimentoSelectFieldProps = CustomSelectFieldProps<TipoParticipacaoAtendimentoSelectModel>

const itemToString = (item: TipoParticipacaoAtendimentoSelectModel) => item && tipoParticipacaoAtendimentoRecord[item]

export function TipoParticipacaoAtendimentoSelectField(props: TipoParticipacaoAtendimentoSelectFieldProps) {
  return (
    <SelectField<TipoParticipacaoAtendimentoSelectModel>
      items={items}
      itemToString={itemToString}
      clearable={false}
      {...props}
    />
  )
}

const items: TipoParticipacaoAtendimentoSelectModel[] = [
  TipoParticipacaoAtendimentoEnum.PRESENCIAL,
  TipoParticipacaoAtendimentoEnum.CHAMADA_DE_VIDEO,
  TipoParticipacaoAtendimentoEnum.CHAMADA_DE_VOZ,
  TipoParticipacaoAtendimentoEnum.EMAIL,
  TipoParticipacaoAtendimentoEnum.MENSAGEM,
  TipoParticipacaoAtendimentoEnum.OUTROS,
]
